<div class="auth-container">
  <!-- Colonne gauche - Branding -->
  <div class="auth-branding">
    <div class="branding-content">
      <h1 class="brand-title">SAL<span class="yellow">OO</span>NS</h1>
      <h2 class="brand-tagline">Ici, on ne swipe pas. On se rencontre.</h2>
    </div>
  </div>

  <!-- Colonne droite - Formulaires -->
  <div class="auth-content">
    <!-- Logo mobile -->
    <div class="mobile-header">
      <h1 class="mobile-title">SAL<span class="yellow">OO</span>NS</h1>
      <h2 class="mobile-tagline">Ici, on ne swipe pas. On se rencontre.</h2>
    </div>

    <div class="auth-form-container">
      <!-- Message d'erreur -->
      @if (errorMessage()) {
      <div class="error-banner">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
        <span>{{ errorMessage() }}</span>
      </div>
      }

      <!-- MODE: INSCRIPTION (page d'accueil) -->
      @if (mode() === 'register') {
      <div class="form-section">
        <h2 class="form-title">S'inscrire</h2>
        <p class="form-subtitle">Rejoignez la communauté Saloons</p>

        <!-- Boutons sociaux -->
        <div class="social-buttons">
          <button
            type="button"
            class="social-btn google-btn"
            (click)="onGoogleAuth()"
            [disabled]="isLoading()"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 48 48">
              <path
                fill="#EA4335"
                d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
              />
              <path
                fill="#4285F4"
                d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
              />
              <path
                fill="#FBBC05"
                d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
              />
              <path
                fill="#34A853"
                d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
              />
            </svg>
            <span>S'inscrire avec Google</span>
          </button>

          <button
            type="button"
            class="social-btn apple-btn"
            (click)="onAppleAuth()"
            [disabled]="isLoading()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                d="M16.55 12.66c-.03-2.77 2.26-4.1 2.36-4.16-1.29-1.88-3.29-2.14-4-2.17-1.7-.17-3.32 1-4.18 1-.87 0-2.2-.97-3.62-.94-1.86.03-3.58 1.08-4.54 2.75-1.94 3.36-.5 8.33 1.39 11.05.93 1.33 2.03 2.83 3.48 2.78 1.39-.06 1.92-.9 3.6-.9 1.68 0 2.16.9 3.63.87 1.5-.03 2.45-1.36 3.37-2.7 1.06-1.55 1.5-3.05 1.52-3.13-.03-.01-2.93-1.12-2.96-4.45zM13.8 4.55c.77-.93 1.29-2.23 1.15-3.52-1.11.04-2.45.74-3.25 1.67-.71.82-1.34 2.14-1.17 3.4 1.23.1 2.5-.63 3.27-1.55z"
              />
            </svg>
            <span>S'inscrire avec Apple</span>
          </button>
        </div>

        <!-- Séparateur -->
        <div class="divider">
          <span>ou</span>
        </div>

        <!-- Bouton inscription email -->
        <button type="button" class="email-btn" (click)="goToRegisterEmail()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
            ></path>
            <polyline points="22,6 12,13 2,6"></polyline>
          </svg>
          <span>S'inscrire avec une adresse email</span>
        </button>

        <p class="legal-consent">
          En cliquant sur «&nbsp;S’inscrire&nbsp;», vous acceptez nos
          <a class="legal-link" routerLink="/cgu"> Conditions d’utilisation </a>
          et notre
          <a class="legal-link" routerLink="/politique-confidentialite">
            Politique de confidentialité
          </a>
          .
          <br />
          <a class="legal-link" routerLink="/mentions-legales">Mentions légales</a>
        </p>

        <!-- Lien connexion -->
        <p class="switch-text">
          Vous avez déjà un compte ?
          <button type="button" class="link-btn" (click)="goToLogin()">Se connecter</button>
        </p>
      </div>
      }

      <!-- MODE: CONNEXION -->
      @if (mode() === 'login') {
      <div class="form-section">
        <h2 class="form-title">Se connecter</h2>
        <p class="form-subtitle">Content de vous revoir !</p>

        <!-- Boutons sociaux -->
        <div class="social-buttons">
          <button
            type="button"
            class="social-btn google-btn"
            (click)="onGoogleAuth()"
            [disabled]="isLoading()"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 48 48">
              <path
                fill="#EA4335"
                d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
              />
              <path
                fill="#4285F4"
                d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
              />
              <path
                fill="#FBBC05"
                d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
              />
              <path
                fill="#34A853"
                d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
              />
            </svg>
            <span>Continuer avec Google</span>
          </button>

          <button
            type="button"
            class="social-btn apple-btn"
            (click)="onAppleAuth()"
            [disabled]="isLoading()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                d="M16.55 12.66c-.03-2.77 2.26-4.1 2.36-4.16-1.29-1.88-3.29-2.14-4-2.17-1.7-.17-3.32 1-4.18 1-.87 0-2.2-.97-3.62-.94-1.86.03-3.58 1.08-4.54 2.75-1.94 3.36-.5 8.33 1.39 11.05.93 1.33 2.03 2.83 3.48 2.78 1.39-.06 1.92-.9 3.6-.9 1.68 0 2.16.9 3.63.87 1.5-.03 2.45-1.36 3.37-2.7 1.06-1.55 1.5-3.05 1.52-3.13-.03-.01-2.93-1.12-2.96-4.45zM13.8 4.55c.77-.93 1.29-2.23 1.15-3.52-1.11.04-2.45.74-3.25 1.67-.71.82-1.34 2.14-1.17 3.4 1.23.1 2.5-.63 3.27-1.55z"
              />
            </svg>
            <span>Continuer avec Apple</span>
          </button>
        </div>

        <!-- Séparateur -->
        <div class="divider">
          <span>ou</span>
        </div>

        <!-- Formulaire connexion -->
        <form [formGroup]="loginForm" (ngSubmit)="onEmailLogin()" class="auth-form">
          <div class="form-group">
            <label for="login-email">Email</label>
            <input
              type="email"
              id="login-email"
              formControlName="email"
              placeholder="votre@email.com"
              [class.invalid]="isFieldInvalid(loginForm, 'email')"
            />
            @if (isFieldInvalid(loginForm, 'email')) {
            <span class="error-text">{{ getFieldError(loginForm, 'email') }}</span>
            }
          </div>

          <div class="form-group">
            <label for="login-password">Mot de passe</label>
            <div class="password-wrapper">
              <input
                [type]="showPassword() ? 'text' : 'password'"
                id="login-password"
                formControlName="password"
                placeholder="••••••••"
                [class.invalid]="isFieldInvalid(loginForm, 'password')"
              />
              <button type="button" class="toggle-password" (click)="togglePasswordVisibility()">
                @if (showPassword()) {
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
                  ></path>
                  <line x1="1" y1="1" x2="23" y2="23"></line>
                </svg>
                } @else {
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
                }
              </button>
            </div>
            @if (isFieldInvalid(loginForm, 'password')) {
            <span class="error-text">{{ getFieldError(loginForm, 'password') }}</span>
            }
          </div>
          <div class="forgot-password">
            <button type="button" class="link-btn" (click)="goToForgotPassword()">
              Mot de passe oublié ?
            </button>
          </div>

          <button type="submit" class="submit-btn" [disabled]="isLoading()">
            @if (isLoading()) {
            <div class="spinner"></div>
            } @else { Se connecter }
          </button>
        </form>

        <!-- Lien inscription -->
        <p class="switch-text">
          Pas encore de compte ?
          <button type="button" class="link-btn" (click)="goToRegister()">S'inscrire</button>
        </p>
      </div>
      }

      <!-- MODE: INSCRIPTION EMAIL -->
      @if (mode() === 'register-email') {
      <div class="form-section">
        <button type="button" class="back-btn" (click)="backToRegister()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
          Retour
        </button>

        <h2 class="form-title">Créer un compte</h2>
        <p class="form-subtitle">Inscrivez-vous avec votre email</p>

        <form [formGroup]="registerForm" (ngSubmit)="onEmailRegister()" class="auth-form">
          <div class="form-row">
            <div class="form-group">
              <label for="register-firstname">Prénom</label>
              <input
                type="text"
                id="register-firstname"
                formControlName="firstName"
                placeholder="Prénom"
                [class.invalid]="isFieldInvalid(registerForm, 'firstName')"
              />
              @if (isFieldInvalid(registerForm, 'firstName')) {
              <span class="error-text">{{ getFieldError(registerForm, 'firstName') }}</span>
              }
            </div>

            <div class="form-group">
              <label for="register-lastname">Nom</label>
              <input
                type="text"
                id="register-lastname"
                formControlName="lastName"
                placeholder="Nom"
                [class.invalid]="isFieldInvalid(registerForm, 'lastName')"
              />
              @if (isFieldInvalid(registerForm, 'lastName')) {
              <span class="error-text">{{ getFieldError(registerForm, 'lastName') }}</span>
              }
            </div>
          </div>

          <div class="form-group">
            <label for="register-email">Email</label>
            <input
              type="email"
              id="register-email"
              formControlName="email"
              placeholder="votre@email.com"
              [class.invalid]="isFieldInvalid(registerForm, 'email')"
            />
            @if (isFieldInvalid(registerForm, 'email')) {
            <span class="error-text">{{ getFieldError(registerForm, 'email') }}</span>
            }
          </div>

          <div class="form-group">
            <label for="register-password">Mot de passe</label>
            <div class="password-wrapper">
              <input
                [type]="showPassword() ? 'text' : 'password'"
                id="register-password"
                formControlName="password"
                placeholder="Minimum 8 caractères"
                [class.invalid]="isFieldInvalid(registerForm, 'password')"
              />
              <button type="button" class="toggle-password" (click)="togglePasswordVisibility()">
                @if (showPassword()) {
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
                  ></path>
                  <line x1="1" y1="1" x2="23" y2="23"></line>
                </svg>
                } @else {
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
                }
              </button>
            </div>
            @if (isFieldInvalid(registerForm, 'password')) {
            <span class="error-text">{{ getFieldError(registerForm, 'password') }}</span>
            }
          </div>

          <div class="form-group">
            <label for="register-confirm">Confirmer le mot de passe</label>
            <div class="password-wrapper">
              <input
                [type]="showConfirmPassword() ? 'text' : 'password'"
                id="register-confirm"
                formControlName="confirmPassword"
                placeholder="••••••••"
                [class.invalid]="isFieldInvalid(registerForm, 'confirmPassword')"
              />
              <button
                type="button"
                class="toggle-password"
                (click)="toggleConfirmPasswordVisibility()"
              >
                @if (showConfirmPassword()) {
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
                  ></path>
                  <line x1="1" y1="1" x2="23" y2="23"></line>
                </svg>
                } @else {
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
                }
              </button>
            </div>
            @if (isFieldInvalid(registerForm, 'confirmPassword')) {
            <span class="error-text">{{ getFieldError(registerForm, 'confirmPassword') }}</span>
            }
          </div>

          <button type="submit" class="submit-btn" [disabled]="isLoading()">
            @if (isLoading()) {
            <div class="spinner"></div>
            } @else { Créer mon compte }
          </button>
        </form>

        <!-- Lien connexion -->
        <p class="switch-text">
          Vous avez déjà un compte ?
          <button type="button" class="link-btn" (click)="goToLogin()">Se connecter</button>
        </p>
      </div>
      }
    </div>
  </div>
</div>
